<dynamic-form
  *ngIf="formGroup !== undefined"
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [columns]="columns"
  [erroremessage]="erroremessage"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content" *ngIf="formGroup !== undefined">
    <div class="detail">
      <editable-grid
        *ngIf="DebtorCreditorNoticesDetailColumns && DebtorCreditorNoticesDetailColumns.length > 0"
        #detail
        [DefaultValues]="DefaultValues"
        [columns]="DebtorCreditorNoticesDetailColumns"
        [dataList]="model.DebtorCreditorNoticesDetailList"
        [isAdd]="!model.AccVoucherHeaderId"
        [isDelete]="!model.AccVoucherHeaderId">
      </editable-grid>
    </div>
  </ng-container>
  <ng-container class="footer">
    <ssg-button
      *hasPermission="['SellCustomer:DebtorCreditorNoticesHeader/CreateAccVoucher', 'Same']"
      icon="icon-create_new_folder-o"
      (click)="accountAccVoucher(true)"
      buttontype="button"
      class="btnfooter"
      tooltip="صدور سند حسابداری"
      [disabled]="isNewRow || model.AccVoucherHeaderId"
      appearance="flat">
    </ssg-button>
    <ssg-button
      *hasPermission="['SellCustomer:DebtorCreditorNoticesHeader/DeleteAccVoucher', 'Same']"
      icon="icon-delete-sweep-outline"
      (click)="accountAccVoucher(false)"
      buttontype="button"
      class="btnfooter"
      tooltip="حذف سند حسابداری"
      [disabled]="isNewRow || !model.AccVoucherHeaderId"
      appearance="flat">
    </ssg-button>
  </ng-container>
</dynamic-form>
